import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Admin from "../views/admin_views/admin/Admin";
import Users from "../views/admin_views/users/Users";
import AdminDashboard from "../views/admin_views/dashboard/Dashboard";
import UserDashboard from "../views/user_views/dashboard/Dashboard";
import ResponsiveDrawer from "../views/admin_views/drawer/ResponsiveDrawer";
import UserResponsiveDrawer from "../views/user_views/drawer/ResponsiveDrawer";
import AdminLogin from "../views/admin_views/accounts/Login";
import Login from "../views/user_views/accounts/Login";
import Register from "../views/user_views/accounts/Register";
import Introduction from "../views/user_views/introduction/Introduction";
import Logout from "../views/user_views/accounts/Logout";
import ViewUser from "../views/admin_views/users/ViewUser";
import ViewAdmin from "../views/admin_views/admin/ViewAdmin";
import CommunityProperty from "../views/user_views/forms/disclosure/property/community-property/CommunityProperty";
import SeparateProperty from "../views/user_views/forms/disclosure/property/separate-property/SeparateProperty";
import FL141 from "../views/user_views/forms/FL141";
import ResponsePacket1 from "../views/user_views/forms/ResponsePacket1";
import AcknowledgementForm from "../views/user_views/forms/disclosure/acknowledgement/AcknowledgementForm";
import AssestsDebits from "../views/user_views/forms/disclosure/property/assestDebit/AssestsDebitsPetitioner";
import IncomeNExpenseRespondent from "../views/user_views/forms/disclosure/property/assestDebit/AssestsDebitsRespondent";
import PetitionerPacket from "../../src/views/user_views/forms/PetitionerPacket";
import ServingCourtForm from "../views/user_views/forms/ServingCourtForm";
import EntryofJudgementNotice from '../../src/views/user_views/forms/completeDivorceJudgement/noticeofEntryofJudgement/EntryofJudgementNotice'
import FamilyLaw from '../views/user_views/forms/completeDivorceJudgement/familyLaw/FamilyLaw'
import LandingPage from "../../src/landingPage/LandingPage";
import ChildSupportInformation from "../../src/views/user_views/forms/completeDivorceJudgement/childSupportInformation/ChildSupportInformation"

import ServingCourtFormRespondant from "../views/user_views/forms/ServingCourtFormRespondant";
import ChildSupportCase from "../../src/views/user_views/forms/completeDivorceJudgement/childSupportCase/ChildSupportCase";

import MaritalSettlementAgreement from "../../src/views/user_views/forms/maritalSettlementAgreement/MaritalSettlementAgreement"
import Instructions from "../../src/views/user_views/forms/completeDivorceJudgement/Instructions"

import FL142 from "../views/user_views/forms/disclosure/fl-142/FL142"
import JudgmentPacketForms from "../views/user_views/forms/completeDivorceJudgement/judgmentPacketForms/JudgmentPacketForms";
import NonGuideLineChildSupport from "../views/user_views/forms/nonGuideLineChildSupport/NonGuideLineChildSupport";
import ProfileInformation from "../../src/views/user_views/forms/profileInformation/ProfileInformation"
import MaritalSettlement from "../views/user_views/forms/maritalSettlementAgreements/maritalSettlement";
import ChildInformation from "../views/user_views/forms/childInformation/ChildInformation";

import changePassword from "../views/user_views/changePassword/changePassword";
import {NegotiateAgreement} from "../views/user_views/forms/Negotiate_Agreement/NegotiateAgreement";
export const dashboardRoutes = (
  <Switch>
    <Route exact path="/Dashboard" render={() => <AdminDashboard />} />
    <Route path="/Users" render={() => <Users />} />
    <Route path="/View User" render={() => <ViewUser />} />
    <Route path="/View Admin" render={() => <ViewAdmin />} />
    <Route path="/Admins" render={() => <Admin />} />
    <Route path="/Logout" render={() => <Logout />} />
    <Route path="/Login" render={() => <Login />} />
    {/* <Route path="/Landing-Page" render={() => <LandingPage />} /> */}
    {/* <Route path="/change-Password" render={() => <changePassword /> } /> */}
    <Route exact path="/" render={() => <AdminDashboard />} />
  </Switch>
);

export const UserdashboardRoutes = (
  <Switch>
    <Route exact path="/introduction" render={() => <Introduction />} />
    <Route path="/marital" render={() => <MaritalSettlementAgreement />}   />
    <Route exact path="/" render={() => <UserDashboard />} />
    <Route path="/Logout" render={() => <Logout />} />
    <Route path="/Login" render={() => <Login />} />
    <Route path="/User-Dashboard" render={() => <UserDashboard />} />
    <Route path="/Introduction" render={() => <Introduction />} />
    <Route path="/User's Information" render={() => <ProfileInformation />} />
    <Route path="/Step 5:Marital Settlement Agreement" render={() => <MaritalSettlementAgreement />}  />
    <Route path="/Child Information" render={() => <ChildInformation />}  />

    {/* <Route path="/change-Password" render={() => <changePassword /> } /> */}
    
    <Route
      path="/Step 1: Start a Divorce"
      render={() => <PetitionerPacket />}
    />
    <Route
      path="/Step 2: Disclose your Financials"
      render={() => <ResponsePacket1 />}
    />
    <Route path="/Step 3: Negotiate an Agreement" render={() => <NegotiateAgreement/>} />
    <Route path="/Acknowledgement Form" render={() => <AcknowledgementForm />} />
    <Route path="/140" render={() => <ResponsePacket1 />} />
    <Route path="/Instructions" render={() => <Instructions />} />
    <Route path="/disclosure/property/community-property" render={() => <CommunityProperty />} />
    <Route path="/separate-property" render={() => <SeparateProperty />} />

    {/* <Route path="/disclosure/property/Income&Expense" render={() => <AssestsDebits />} /> */}
    <Route path="/disclosure/property/Income&ExpensePetitioner" render={() => <AssestsDebits />} />
    <Route path="/disclosure/property/Income&ExpenseRespondent" render={() => <IncomeNExpenseRespondent />} />
    <Route path="/disclosure/fl-142" render={() => <FL142 />} />

    <Route path="/Step 4: Complete Divorce Judgment" render={() => <FL141 />} />
    <Route
      path="/Acknowledgement Form"
      render={() => <AcknowledgementForm />}
    />
    <Route path="/140" render={() => <ResponsePacket1 />} />
    <Route path="/ServingCourtForm/Respondent" render={() => <ServingCourtFormRespondant/>} />
    
    <Route
      path="/disclosure/property/community-property"
      render={() => <CommunityProperty />}
    />
    <Route path="/ServingCourtForm" render={() => <ServingCourtForm />} />
    <Route path="/notice_of_Entry_of_Judgement" render={() => <EntryofJudgementNotice />} />
    <Route path="/family_law" render={()=> <FamilyLaw />} />
    <Route path="/child_support_information" render={()=> <ChildSupportInformation />} />
    <Route path="/child_support_case" render={()=> <ChildSupportCase />} />
    <Route path="/non_guideline_child_support" render={()=> <NonGuideLineChildSupport />} />
    <Route path="/judgment_packet_forms" render={()=> <JudgmentPacketForms />} />
    <Route path="/marital_settlement" render={()=> <MaritalSettlement />} />
    {/* <Route path="/change-Password" render={() => <changePassword /> } /> */}
  </Switch>
);

export const routes =
  window.localStorage.getItem("isAuthenticated") === "true" &&
    typeof window.localStorage.getItem("auth_id") !== "undefined" ? (
      window.localStorage.getItem("isAdmin") === "true" ? (
        <Switch>
          <Route exact path="/" component={ResponsiveDrawer} />
          <Route exact path="/admin-login" component={Login} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
          {/* <Route path="/change-Password" component={changePassword} /> */}

          <Redirect to="/" />
        </Switch>
      ) : (
          <Switch>
            <Route exact path="/Introduction" component={UserResponsiveDrawer} />
            <Route exact path="/Landing-Page" component={LandingPage} />
            <Route exact path="/admin-login" component={Login} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route path="/change-Password" component={changePassword} />
            <Route path="/Landing-Page" component={LandingPage} />
            <Redirect to="/login" />
          </Switch>
        )
    ) : (
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/admin-login" component={AdminLogin} />
        <Route path="/test" render={() => <PetitionerPacket />} />
        {/* <Route path="/change-Password" component={changePassword} /> */}
        <Redirect to="/" />
      </Switch>
    );
